!function(t){(function(t,e){}).bind(t('section[data-section-id="q6kb5u3qhi"]').get(0))({url:"https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/XCf6EtYraiR1SDnG/banner/",settings:{}},jQuery)}(jQuery),function(t){(function(t,e){}).bind(t('section[data-section-id="hn7ijh2p0if"]').get(0))({url:"https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/CVfr8wvb4qOin5Wd/benefits/",settings:{}},jQuery)}(jQuery),console.log("This page layout has been built by https://www.layouthub.com");

document.addEventListener('DOMContentLoaded', function() {
  // Initialize AOS (Animate On Scroll) if available
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  }

  // Add animation classes to items
  const items = document.querySelectorAll('.lh-item');
  items.forEach((item, index) => {
    item.setAttribute('data-aos', 'fade-up');
    item.setAttribute('data-aos-delay', (index * 100).toString());
  });

  // Handle image lazy loading
  const lazyImages = document.querySelectorAll('.lh-img img[data-src]');
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    lazyImages.forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  // Add hover effect to items
  items.forEach(item => {
    item.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-5px)';
      this.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.1)';
    });

    item.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 2px 15px rgba(0, 0, 0, 0.05)';
    });
  });

  // Handle LayoutHub specific functionality
  if (window.LHPAGE) {
    // Add any LayoutHub specific initialization here
    console.log('LayoutHub page initialized:', window.LHPAGE.id);
  }
});